import {
  useKineticMap,
  getNodes,
  MapContext,
  DEFAULT_ZOOM,
  useMapBoxSearchContext,
  MapSearchResultItem,
  useMapSearchBoxPin,
} from '@kinetic-ui/shared';
import { useCallback, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import bbox from '@turf/bbox';
import { BBox2d } from '@turf/helpers/dist/js/lib/geojson';
import { DirectionsCar } from '@mui/icons-material';
import { ENTITY_DRAWER_VIEW_ALL_ROUTE } from '../EntityList/const';
import { useFleetShiftSearchQuery } from '@kinetic-ui/data-layer';

const MapSearchResult = () => {
  const { hasEntityDrawer } = useContext(MapContext);
  const { addMapPin, removeMapPin } = useMapSearchBoxPin();
  const { searchText } = useMapBoxSearchContext();
  const { push } = useHistory();
  const map = useKineticMap();

  const { data } = useFleetShiftSearchQuery({
    variables: { searchText, limit: 5 },
    fetchPolicy: 'cache-and-network',
  });

  const fleetShifts = getNodes(data?.fleetShifts) ?? [];
  const onClick = useCallback(
    (id: string, geometry?: any) => {
      if (!hasEntityDrawer) {
        addMapPin(geometry);
        return;
      }

      push(`/${ENTITY_DRAWER_VIEW_ALL_ROUTE}/${id}`);
      const bounds = (geometry ? bbox(geometry) : [0, 0, 0, 0]) as BBox2d;
      map.fitBounds([
        [bounds[0], bounds[1]],
        [bounds[2], bounds[3]],
      ]);
      map.setZoom(DEFAULT_ZOOM);
    },
    [addMapPin, hasEntityDrawer, map, push]
  );

  useEffect(() => {
    !hasEntityDrawer && searchText?.length > 0 && removeMapPin();
    // only do this when searchText changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  return (
    <>
      {fleetShifts.map(({ id, vehicleName, location }) => (
        <MapSearchResultItem
          onClick={() => onClick(id, location)}
          key={`searchItem_${id}`}
          icon={<DirectionsCar />}
          name={vehicleName}
        />
      ))}
    </>
  );
};

export default MapSearchResult;
